(function () {
  // فقط روی product page
  console.log("[SR] script loaded");
  console.log("[SR] config exists:", !!window.__SAMPLE_REQUEST_DATA__);

  if (!window.__SAMPLE_REQUEST_DATA__) return;

  const cfg = window.__SAMPLE_REQUEST_DATA__;
  console.log("[SR] config:", cfg);
  const apiBase = "https://sample-request.medisa.au";

  // پیدا کردن جای مناسب: زیر Add to cart
  const atcBtn =
    document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('button[type="submit"]');
  console.log("[SR] atcBtn found:", atcBtn);
  console.log("[SR] atcBtn parent:", atcBtn ? atcBtn.parentElement : null);
  if (!atcBtn) return;

//   // دکمه request sample
//   const btn = document.createElement("button");
//   btn.type = "button";
//   btn.textContent = "Request sample";
//   btn.setAttribute("aria-haspopup", "dialog");
//   const atcStyles = window.getComputedStyle(atcBtn);


//   btn.style.cssText = [
//     "margin-top:10px",
//     // `width:${atcBtn.offsetWidth}px`,
//     "width:100%",
//     `height:${atcBtn.offsetHeight}px`,
//     `border-radius:${atcStyles.borderRadius}`,
//     "border:2px solid rgba(0,0,0,.25)",
//     "background:transparent",
//     "color:#111",
//     "font-weight:700",
//     "font-size:15px",
//     "cursor:pointer",
//   ].join(";");

//   // wrapper برای اینکه مثل عکس شما زیر add to cart بیاد
//   btn.classList.add("md-sample-request-btn");

// atcBtn.parentElement.appendChild(btn);


const btn = document.querySelector(".md-sample-request-btn");

if (!btn) {
  console.warn("[SR] sample request button not found");
  return;
}

btn.setAttribute("aria-haspopup", "dialog");


console.log("[SR] sample button parent:", btn.parentElement);

  console.log(
    "[GQ] quote button found:",
    document.querySelector("#md-add-to-quote")
  );

  console.log(
    "[GQ] quote button parent:",
    document.querySelector("#md-add-to-quote")?.parentElement
  );

  // Drawer HTML
  const drawer = document.createElement("div");
  drawer.id = "sr-drawer";
  drawer.innerHTML = `
    <div id="sr-backdrop" style="position:fixed;inset:0;background:rgba(0,0,0,.35);opacity:0;pointer-events:none;transition:opacity .18s;z-index:9998"></div>
    <aside role="dialog" aria-modal="true" aria-label="Request sample"
      style="position:fixed;top:0;right:0;height:100vh;width:min(420px,92vw);background:#fff;transform:translateX(110%);transition:transform .2s;z-index:9999;box-shadow:-20px 0 40px rgba(0,0,0,.15);display:flex;flex-direction:column;">
      <div style="padding:16px 16px 10px;border-bottom:1px solid rgba(0,0,0,.08);display:flex;align-items:center;justify-content:space-between;gap:10px">
        <div style="font-size:18px;font-weight:800">Request sample</div>
        <button id="sr-close" type="button" style="border:none;background:transparent;font-size:28px;line-height:1;cursor:pointer">×</button>
      </div>

      <div style="padding:16px;overflow:auto">
        <div style="font-weight:800;margin-bottom:10px">${escapeHtml(cfg.product_title || "")}</div>

       <div id="sr-size-wrap">
  <label style="display:block;font-size:13px;font-weight:700;margin:12px 0 6px">Size</label>
  <select id="sr-size" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px"></select>
</div>

        <label style="display:block;font-size:13px;font-weight:700;margin:12px 0 6px">Email</label>
        <input id="sr-email" type="email" placeholder="Email" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />

        <label style="display:block;font-size:13px;font-weight:700;margin:12px 0 6px">Phone</label>
        <input id="sr-phone" type="tel" placeholder="Phone" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />

        <div style="margin-top:12px;font-size:13px;font-weight:800">Address</div>

<label style="display:block;font-size:13px;font-weight:700;margin:10px 0 6px">Country/region</label>
<select id="sr-country" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px">
  <option value="Australia" selected>Australia</option>
</select>

<div style="display:flex;gap:10px;margin-top:12px">
  <div style="flex:1">
    <label style="display:block;font-size:13px;font-weight:700;margin:0 0 6px">First name</label>
    <input id="sr-first" type="text" placeholder="First name" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />
  </div>
  <div style="flex:1">
    <label style="display:block;font-size:13px;font-weight:700;margin:0 0 6px">Last name</label>
    <input id="sr-last" type="text" placeholder="Last name" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />
  </div>
</div>

<label style="display:block;font-size:13px;font-weight:700;margin:12px 0 6px">Company</label>
<input id="sr-company" type="text" placeholder="Company" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />

<label style="display:block;font-size:13px;font-weight:700;margin:12px 0 6px">Address</label>
<input id="sr-address1" type="text" placeholder="Address" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />

<label style="display:block;font-size:13px;font-weight:700;margin:12px 0 6px">Apartment, suite, etc (optional)</label>
<input id="sr-address2" type="text" placeholder="Apartment, suite, etc (optional)" style="width:100%;height:42px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px" />

<div style="display:flex;gap:10px;margin-top:12px;align-items:flex-start;">
  <div style="flex:1 1 0;min-width:0;">
    <label style="display:block;font-size:13px;font-weight:700;margin:0 0 6px">Suburb</label>
    <input id="sr-suburb" type="text" placeholder="Suburb" style="display:block;width:100%;height:44px;min-height:44px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px;box-sizing:border-box;" />
  </div>
  <div style="flex:1 1 0;min-width:0;">
    <label style="display:block;font-size:13px;font-weight:700;margin:0 0 6px">State/territory</label>
    <select id="sr-state" style="display:block;width:100%;height:44px;min-height:44px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 36px 0 12px;box-sizing:border-box;background:#fff;">
      <option value="" selected>Select an option</option>
      <option value="ACT">Australian Capital Territory</option>
      <option value="NSW">New South Wales</option>
      <option value="NT">Northern Territory</option>
      <option value="QLD">Queensland</option>
      <option value="SA">South Australia</option>
      <option value="TAS">Tasmania</option>
      <option value="VIC">Victoria</option>
      <option value="WA">Western Australia</option>
    </select>
  </div>
  <div style="flex:1 1 0;min-width:0;">
    <label style="display:block;font-size:13px;font-weight:700;margin:0 0 6px">Postcode</label>
    <input id="sr-postcode" type="text" inputmode="numeric" placeholder="Postcode" style="display:block;width:100%;height:44px;min-height:44px;border-radius:12px;border:1px solid rgba(0,0,0,.18);padding:0 12px;box-sizing:border-box;" />
  </div>
</div>
        <button id="sr-submit" type="button"
          style="margin-top:14px;width:100%;height:44px;border-radius:12px;border:none;background:#ff4d2d;color:#fff;font-weight:800;cursor:pointer">
          Submit
        </button>

        <div id="sr-msg" style="margin-top:10px;font-size:13px;"></div>
      </div>
    </aside>
  `;
  document.body.appendChild(drawer);

  const backdrop = drawer.querySelector("#sr-backdrop");
  const panel = drawer.querySelector("aside");
  const closeBtn = drawer.querySelector("#sr-close");
  const sizeSel = drawer.querySelector("#sr-size");
  const sizeWrap = drawer.querySelector("#sr-size-wrap");

  const isPackaging = String(cfg.option_name || "").trim().toLowerCase() === "packaging";
  if (isPackaging && sizeWrap) {
    sizeWrap.style.display = "none";
  }

  const emailInp = drawer.querySelector("#sr-email");
  const phoneInp = drawer.querySelector("#sr-phone");
  // const addrInp = drawer.querySelector("#sr-address");
  const countrySel = drawer.querySelector("#sr-country");
  const firstInp = drawer.querySelector("#sr-first");
  const lastInp = drawer.querySelector("#sr-last");
  const companyInp = drawer.querySelector("#sr-company");
  const address1Inp = drawer.querySelector("#sr-address1");
  const address2Inp = drawer.querySelector("#sr-address2");
  const suburbInp = drawer.querySelector("#sr-suburb");
  const stateSel = drawer.querySelector("#sr-state");
  const postcodeInp = drawer.querySelector("#sr-postcode");

  const submitBtn = drawer.querySelector("#sr-submit");
  const msg = drawer.querySelector("#sr-msg");

  // Fill: sizes
  const sizes = extractSizes(cfg);
  sizes.forEach((s) => {
    const opt = document.createElement("option");
    opt.value = s.value;
    opt.textContent = s.label;
    sizeSel.appendChild(opt);
  });

  // Fill email if logged in
  if (cfg.customer_email) emailInp.value = cfg.customer_email;

  function open() {
    backdrop.style.opacity = "1";
    backdrop.style.pointerEvents = "auto";
    panel.style.transform = "translateX(0)";
  }
  function close() {
    backdrop.style.opacity = "0";
    backdrop.style.pointerEvents = "none";
    panel.style.transform = "translateX(110%)";
    msg.textContent = "";
    msg.style.color = "#111";
    submitBtn.disabled = false;
    submitBtn.style.opacity = "1";
  }

  btn.addEventListener("click", open);
  backdrop.addEventListener("click", close);
  closeBtn.addEventListener("click", close);

  submitBtn.addEventListener("click", async () => {
    msg.textContent = "";
    const email = (emailInp.value || "").trim();
    const phone = (phoneInp.value || "").trim();

    const address_fields = {
      country: (countrySel?.value || "Australia").trim(),
      first_name: (firstInp.value || "").trim(),
      last_name: (lastInp.value || "").trim(),
      company: (companyInp.value || "").trim(),
      address1: (address1Inp.value || "").trim(),
      address2: (address2Inp.value || "").trim(),
      suburb: (suburbInp.value || "").trim(),
      state: (stateSel.value || "").trim(),
      postcode: (postcodeInp.value || "").trim(),
    };

    // یک رشته‌ی استاندارد برای ارسال/نمایش
    const address = [
      [address_fields.first_name, address_fields.last_name].filter(Boolean).join(" "),
      address_fields.company,
      address_fields.address1,
      address_fields.address2,
      [address_fields.suburb, address_fields.state, address_fields.postcode].filter(Boolean).join(" "),
      address_fields.country,
    ].filter(Boolean).join(", ");

    const size = sizeSel.value;

    if (!email) {
      msg.style.color = "#b00020";
      msg.textContent = "Please enter your email.";
      return;
    }
    if (!isPackaging && !size) {
      msg.style.color = "#b00020";
      msg.textContent = "Please select a size.";
      return;
    }


    submitBtn.disabled = true;
    submitBtn.style.opacity = "0.7";
    const selectedSize = isPackaging ? "" : (sizeSel.value || "");

    let matchedVariantId = "";
    if (!isPackaging) {
      const match = (cfg.variants || []).find(v => v.option1 === selectedSize);
      if (match && match.id) matchedVariantId = match.id;

      // اگر variant پیدا نشد، جلوی ارسال رو بگیر (همون پیشنهادی که قبل‌تر دادم)
      if (!matchedVariantId) {
        msg.style.color = "#b00020";
        msg.textContent = "Please select a valid size.";
        submitBtn.disabled = false;
        submitBtn.style.opacity = "1";
        return;
      }
    }

    if (!address_fields.first_name || !address_fields.last_name) {
      msg.style.color = "#b00020";
      msg.textContent = "Please enter your first and last name.";
      return;
    }
    if (!address_fields.address1 || !address_fields.suburb || !address_fields.state || !address_fields.postcode) {
      msg.style.color = "#b00020";
      msg.textContent = "Please complete your address (Address, Suburb, State, Postcode).";
      return;
    }

    try {
      const payload = {
        store_domain: cfg.store_domain,
        product_title: cfg.product_title,
        product_handle: cfg.product_handle,
        product_id: cfg.product_id,
        variant_id: matchedVariantId || "",
        size_label: selectedSize,
        customer_email: email,
        phone,
        address, address_fields,
        page_url: window.location.href,
      };

      const r = await fetch(`${apiBase}/api/sample-request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!r.ok) throw new Error("REQUEST_FAILED");

      msg.style.color = "#0a7a27";
      msg.textContent = "Your request has been received. We will contact you.";
      // اگر خواستی بعد از چند ثانیه drawer بسته شود، بگو اضافه کنم.
    } catch (e) {
      msg.style.color = "#b00020";
      msg.textContent = "Something went wrong. Please try again.";
      submitBtn.disabled = false;
      submitBtn.style.opacity = "1";
    }
  });

  function extractSizes(cfg) {
    // اولین آپشن = option1
    const set = new Set();
    (cfg.variants || []).forEach((v) => {
      if (v && v.option1) set.add(v.option1);
    });

    const values = Array.from(set);

    // اگر هیچ آپشنی نبود
    if (!values.length) return [{ value: "", label: "No options found" }];

    return values.map((v) => ({ value: v, label: v }));
  }


  function escapeHtml(s) {
    return String(s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }
})();
